
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
// Tailwind migration: inline classes

const Footer = () => {
  return (
    <footer className="mt-16 border-t border-border bg-foreground/[0.02]">
      <div className="container py-10">
        
             
          <div className="flex justify-center">
            <ul className="mt-3 flex items-center gap-4">
              <li>
                <a className="hover:text-primary transition-colors" href="https://linkedin.com/in/prajwal-kabbur" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <FaLinkedin size={15} />
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="https://github.com/PRAJWAL-KABBUR" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                  <FaGithub size={15} />
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="mailto:prajwalskabbur@gmail.com" aria-label="Email">
                  <FaEnvelope size={15} />
                </a>
              </li>
            </ul>
          </div>
        

        <div className="mt-8 border-t border-border pt-4 text-center text-xs text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Prajwal Kabbur. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;